import React from "react";
import { ReactComponent as UsdtSvg } from "../assets/payments/usdt.svg";

function Star({ cx, cy, r = 2.1 }) {
  const pts = Array.from({ length: 10 }, (_, i) => {
    const a = ((-90 + i * 36) * Math.PI) / 180;
    const rad = i % 2 === 0 ? r : r * 0.4;
    return `${cx + Math.cos(a) * rad},${cy + Math.sin(a) * rad}`;
  }).join(" ");
  return <polygon points={pts} fill="#ffcc00" />;
}

const marks = {
  TRY: (
    <svg viewBox="0 0 32 32" aria-hidden>
      <rect width="32" height="32" fill="#e30a17" />
      <circle cx="13.2" cy="16" r="7.1" fill="#fff" />
      <circle cx="15.1" cy="16" r="5.6" fill="#e30a17" />
      <polygon fill="#fff" points="19.6,16 22.7,17.15 20.85,14.4 20.85,17.6 22.7,14.85" />
    </svg>
  ),
  USDT: <UsdtSvg aria-hidden />,
};

const FxMark = ({ code, className = "" }) => (
  <span className={`fx-mark${className ? ` ${className}` : ""}`} data-fx={code} aria-hidden>
    {marks[code] || marks.TRY}
  </span>
);

export default FxMark;
